import { createContext } from 'react';

const useSalesWeeklyReportContext = createContext();
export default useSalesWeeklyReportContext;
